<div class="wrapper">
    <!-- Sidebar  -->
    <nav id="sidebar" class="active">

        <div class="no-border no-padding padding-top">
            <img src="./../../../../assets/img/loguito.png" width="30" height="30" class="d-inline-block align-top"
                alt="" style="margin-left: auto !important; margin-right: auto !important; display: block !important;">
        </div>

        <ul class="list-unstyled components">
            <div id="accordion">

                <!-- HOME -->
                <div *ngIf="currentUser">
                    <div class="nav-item" routerLinkActive="active" placement="right" triggers="mouseenter:mouseleave"
                        ngbPopover={{currentUser}}>
                        <a class="nav-link menu-pad">
                            <i class="fa fa-user-circle-o fa-2x" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
                <!-- USUARIO -->
                <div>
                    <div class="nav-item" routerLinkActive="active" placement="right" triggers="mouseenter:mouseleave"
                        ngbPopover="Principal">
                        <a class="nav-link menu-pad" [routerLink]="['home']">
                            <i class="fa fa-home menu-icon fa-2x" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
                <!-- BUSQUEDA -->
                <div> 
                    <a class="nav-link collapsed menu-pad" data-toggle="collapse" data-target="#collapseMenuOne"
                        aria-expanded="false" aria-controls="collapseMenuOne" ngbPopover="Buscar"
                        triggers="mouseenter:mouseleave" placement="right">
                        <i class="fa fa-search menu-icon fa-2x" aria-hidden="true"></i>
                    </a>
                    <div id="collapseMenuOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
                        <li class="nav-item" routerLinkActive="active" placement="right"
                            triggers="mouseenter:mouseleave" ngbPopover="Cliente">
                            <a class="nav-link" (click)="GoToBPLog()">
                                <i class="fa fa-users fa-2x" aria-hidden="true"></i>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active" placement="right"
                            triggers="mouseenter:mouseleave" ngbPopover="Compañía">
                            <a class="nav-link" (click)="GoToCompanyLog()">
                                <i class="fa fa-building fa-2x" aria-hidden="true"></i>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active" placement="right"
                            triggers="mouseenter:mouseleave" ngbPopover="Proveedores">
                            <a class="nav-link" (click)="GoToSupplierLog()">
                                <i class="fa fa-users fa-2x" aria-hidden="true"></i>
                            </a>
                        </li>
                    </div>
                </div>


                <!-- MANTENIMIENTO -->
                <div>
                    <a class="nav-link collapsed menu-pad" data-toggle="collapse" data-target="#collapseMenuThree"
                        aria-expanded="false" aria-controls="collapseMenuThree" ngbPopover="Reportes"
                        triggers="mouseenter:mouseleave" placement="right">
                        <i class="fa fa-cog fa-2x menu-icon" aria-hidden="true"></i>
                    </a>
                    <div id="collapseMenuThree" class="collapse" aria-labelledby="headingThree"
                        data-parent="#accordion">
                        <li class="nav-item" routerLinkActive="active" placement="right"
                            triggers="mouseenter:mouseleave" ngbPopover="Alertas">
                            <a class="nav-link" (click)="GoToCreateAlert()">
                                <i class="fa fa-bell subtitle" aria-hidden="true"></i>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active" placement="right"
                            triggers="mouseenter:mouseleave" ngbPopover="Compañías">
                            <a class="nav-link" (click)="GoToCreateCompany()">
                                <i class="fa fa-building subtitle" aria-hidden="true"></i>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active" placement="right"
                            triggers="mouseenter:mouseleave" ngbPopover="Alerta por Compañía">
                            <a class="nav-link" (click)="GoToAssignAlertToCompany()">
                                <i class="fa fa-plus subtitle" aria-hidden="true"></i>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active" placement="right"
                            triggers="mouseenter:mouseleave" ngbPopover="Gestor">
                            <a class="nav-link" (click)="GoToManager()">
                                <i class="fa fa-user subtitle" aria-hidden="true"></i>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active" placement="right"
                            triggers="mouseenter:mouseleave" ngbPopover="Gestor por Compañía">
                            <a class="nav-link" (click)="GoToManagerByCompany()">
                                <i class="fa fa-sort-amount-asc subtitle" aria-hidden="true"></i>
                            </a>
                        </li>
                    </div>
                </div>

                <div class="nav-item" placement="right" triggers="mouseenter:mouseleave" ngbPopover="Salir">
                    <a class="nav-link menu-pad" (click)="logout()">
                        <i class="fa fa-sign-out fa-2x menu-icon" aria-hidden="true"></i>
                    </a>
                </div>


            </div>

        </ul>

    </nav>


    <!-- Page Content  -->
    <div id="content">
        <div>
            <router-outlet></router-outlet>
        </div>
    </div>

</div>